import React from "react";
import { Building2, MapPin, Phone, Smartphone, ExternalLink } from "lucide-react";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import BranchModel from "../../Models/BranchModel";
import { Link } from "react-router-dom";
function BranchInfo(props: { branch: BranchModel }) {
  const { name } = indexStore();
  const { t } = useTranslation();

  // التأكد من وجود branch
  if (!props.branch || Object.keys(props.branch).length === 0) {
    return (
      <div className="flex flex-col gap-4">
        <h3 className="text-lg font-bold text-foreground border-b border-border pb-2">
          {t("gloabl.branchInfo")}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t("gloabl.noDataAvailable") || "No data available"}
        </p>
      </div>
    );
  }

  // تحديد مفتاح العنوان بناءً على اللغة
  const addressKey = name === "name_en" ? "address_en" : "address_ar";
  const branchName = props.branch[name as keyof BranchModel];
  const address = props.branch[addressKey as keyof BranchModel];

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2 pb-2 border-b border-primary/20">
        <div className="p-1 rounded-md bg-primary/10 border border-primary/20">
          <Building2 className="w-4 h-4 text-primary" />
        </div>
        <h3 className="text-base font-bold text-foreground">
          {t("gloabl.branchInfo")}
        </h3>
      </div>

      <div className="flex flex-col gap-2">
        {/* اسم الفرع */}
        {branchName && (
          <div className="flex items-center gap-2.5 p-2.5 rounded-lg bg-muted/40 border border-border/40 hover:border-primary/30 hover:bg-muted/60 transition-all duration-200 group">
            <div className="flex-shrink-0 p-1.5 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors">
              <Building2 className="w-4 h-4 text-primary" />
            </div>
            <p className="text-sm font-semibold text-foreground break-words group-hover:text-primary transition-colors">
              {branchName}
            </p>
          </div>
        )}

        {/* العنوان */}
        {address && (
          <div className="flex items-start gap-2.5 p-2.5 rounded-lg bg-muted/40 border border-border/40 hover:border-primary/30 hover:bg-muted/60 transition-all duration-200 group">
            <div className="flex-shrink-0 p-1.5 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors mt-0.5">
              <MapPin className="w-4 h-4 text-primary" />
            </div>
            <p className="text-sm font-medium text-foreground break-words group-hover:text-primary transition-colors flex-1">
              {address}
            </p>
          </div>
        )}

        {/* الهاتف */}
        <Visibility visible={!!props.branch.phone}>
          <Link
            to={`tel:${props.branch.phone}`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-2.5 p-2.5 rounded-lg bg-muted/40 border border-border/40 hover:border-primary/30 hover:bg-muted/60 transition-all duration-200 group"
          >
            <div className="flex-shrink-0 p-1.5 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors">
              <Phone className="w-4 h-4 text-primary" />
            </div>
            <p dir="ltr" className="text-sm font-semibold text-primary group-hover:underline flex-1">
              {props.branch.phone}
            </p>
            <ExternalLink className="w-3.5 h-3.5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
          </Link>
        </Visibility>

        {/* الجوال */}
        <Visibility visible={!!props.branch.mobile}>
          <Link
            to={`tel:${props.branch.mobile}`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-2.5 p-2.5 rounded-lg bg-muted/40 border border-border/40 hover:border-primary/30 hover:bg-muted/60 transition-all duration-200 group"
          >
            <div className="flex-shrink-0 p-1.5 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors">
              <Smartphone className="w-4 h-4 text-primary" />
            </div>
            <p dir="ltr" className="text-sm font-semibold text-primary group-hover:underline flex-1">
              {props.branch.mobile}
            </p>
            <ExternalLink className="w-3.5 h-3.5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
          </Link>
        </Visibility>
      </div>
    </div>
  );
}

export default BranchInfo;
